var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/** @jsx jsx */
import { jsx } from 'theme-ui';
import { forwardRef } from 'react';
export var CustomScroll = forwardRef(function (props, ref) {
    return (jsx("div", __assign({}, props, { ref: ref, sx: {
            overflowY: 'auto',
            '&::-webkit-scrollbar': {
                bg: 'background',
                width: 14,
            },
            '&::-webkit-scrollbar-thumb': {
                bg: 'primary',
                borderRadius: 7,
            },
        } })));
});
//# sourceMappingURL=CustomScroll.js.map